<template>
	<!-- 商砼站管理 -->
	<div class="billOperationRecord public_Spacing system-commercial-concrete-stand-page">
		<div class="pulbic_oparetionBlock commercial-stand-filter-panel" style="margin-bottom: 12px;">
			<div class="commercial-stand-filter-head">
				<div>
					<div class="commercial-stand-filter-title">商砼站管理</div>
					<div class="commercial-stand-filter-subtitle">维护商混站基础信息、联系人和地址</div>
				</div>
				<div class="commercial-stand-filter-count">共 {{ pagingPageMo || 0 }} 条</div>
			</div>
			<div class="public_criteriaRange commercial-stand-filter-controls">

				<div class="public_oparetionBlock_Menu commercial-stand-filter-item">
					<label class="public_lbSty nameshz-clas">商混站名称：</label>
					<div class="el-select public_optionSty">
						<div class="el-input el-input--suffix">
							<input class="pulic_carNumber" type="text" placeholder="请输入" v-model="ORMTB473CA00" />
						</div>
					</div>
				</div>

			</div>

			<div class="public_operatArea commercial-stand-action-area">
				<div class="public_operatBtn commercial-stand-action-btns" style="margin-left: 0;">
					<button @click="queryClick" class="public_saleWater_chaxun pulic_cursor" id="查询"><i
							class="iconfont icon-chaxun"></i>查询</button>
					<button @click="newlyAdd" class="public_saleWater_xinzeng pulic_cursor" id="新增"><i
							class="iconfont icon-tianjia1"></i>新增</button>
				
				</div>
			</div>
		</div>

		<div class="billOperationRecord-table pulbic_table_container commercial-stand-table-card">
			<div class="commercial-stand-table-head">
				<div class="commercial-stand-table-title">商混站列表</div>
				<div class="commercial-stand-table-tag">基础资料</div>
			</div>
			<el-table tooltip-effect="dark" :data="tableData" style="width: 100%;"
				:default-sort="{prop: 'waterNum', order: 'descending'}"
				:header-cell-style="{color:'rgba(51,51,51,1)', background:'rgba(184,227,255,1)','font-weight':'bold'}"
				class="public_tableColumn commercial-stand-main-table">
				<el-table-column v-for='(item,index) in tableHeadList' :width="item.width" :prop="item.prop"
					:label="item.label" :key="index">
				</el-table-column>
				<el-table-column v-if="this.uobj.pertb005.pertb005cb00 =='CUS-1'" label="操作" fixed="right" width="300">
					<template slot-scope="scope">
						
						<el-button @click="modify(scope.row)"
							class="public_icon_xiugai public_icon_width  public_icon_margin" id="修改" type="primary"
							size="small">修改</el-button>
							<el-button class="public_icon_jinyong public_icon_width public_icon_margin" type="danger" size="small" @click="deleteClick(scope.row)">删除</el-button>

					</template>
				</el-table-column>
			</el-table>
			<div class="pulbic_pagesize">
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
					:current-page.sync="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="limitMo"
					layout="total,sizes, prev, pager, next, jumper" :total="pagingPageMo">
				</el-pagination>
			</div>
		</div>


		<!-- 新增 -->
		<div class="public-dialog">
			<el-dialog title="新增商混站信息" @close="XAdd" :visible.sync="billOperationAdd" width="40%"
				:closeOnClickModal='false' append-to-body custom-class="system-settings-system-commercial-concrete-stand-dialog">
				<div class="systemCodePC-add-code">
					<div class="systemCodePC-add-code-table">
						<div class="systemCodePC-add-code-table-li">
							<div class="systemCodePC-add-code-table-li-name">商混站名称</div>
							<div class="systemCodePC-add-code-table-li-ipt">
								<input type="text" class="car-number-add" :maxlength="maxl" v-model="ORMTB473CA00ADD" />
							</div>
							<div class="systemCodePC-add-code-table-li-text">*必填*</div>
						</div>
						<div class="systemCodePC-add-code-table-li">
							<div class="systemCodePC-add-code-table-li-name">联系人</div>
							<div class="systemCodePC-add-code-table-li-ipt">
								<input type="text" class="car-number-add" :maxlength="maxl" v-model="ORMTB473CA06" />
							</div>
							<div class="systemCodePC-add-code-table-li-text">*必填*</div>
						</div>

						<div class="systemCodePC-add-code-table-li">
							<div class="systemCodePC-add-code-table-li-name">手机号</div>
							<div class="systemCodePC-add-code-table-li-ipt">
								<input type="text" class="car-number-add" maxlength="11" v-model="ORMTB473CA10ADD" />
							</div>
							<div class="systemCodePC-add-code-table-li-text">*必填*</div>
						</div>

						<div class="systemCodePC-add-code-table-li">
							<div class="systemCodePC-add-code-table-li-name">地址</div>
							<div class="systemCodePC-add-code-table-li-ipt" @click="adresOpiFun()">
								<input type="text" disabled style="pointer-events:none" placeholder="点击选择地址"
									v-model="ORMTB473CA01ADD" />
							</div>
							<div class="systemCodePC-add-code-table-li-text">*必填*</div>
						</div>

					</div>
					<div class="systemCodePC-add-code-btn">
						<el-button type="warning" @click="cancelAdd">取消</el-button>
						<el-button type="primary" @click="preservationAdd">保存</el-button>
					</div>
				</div>
			</el-dialog>
		</div>
		<!-- 修改 -->
		<div class="public-dialog">
			<el-dialog title="修改商混站信息" @close="XAdd" :visible.sync="billOperationDetails" width="40%"
				:closeOnClickModal='false' append-to-body custom-class="system-settings-system-commercial-concrete-stand-dialog">
				<div class="systemCodePC-add-code">

					<div class="systemCodePC-add-code-table">
						<div class="systemCodePC-add-code-table-li">
							<div class="systemCodePC-add-code-table-li-name">商混站名称</div>
							<div class="systemCodePC-add-code-table-li-ipt">
								<input type="text" class="car-number-add" :maxlength="maxl" v-model="modifyObj.ORMTB491CA00" />
							</div>
							<div class="systemCodePC-add-code-table-li-text">*必填*</div>
						</div>
						<div class="systemCodePC-add-code-table-li">
							<div class="systemCodePC-add-code-table-li-name">联系人</div>
							<div class="systemCodePC-add-code-table-li-ipt">
								<input type="text" class="car-number-add" :maxlength="maxl" v-model="modifyObj.ORMTB491CA04" />
							</div>
							<div class="systemCodePC-add-code-table-li-text">*必填*</div>
						</div>

						<div class="systemCodePC-add-code-table-li">
							<div class="systemCodePC-add-code-table-li-name">手机号</div>
							<div class="systemCodePC-add-code-table-li-ipt">
								<input type="text" class="car-number-add" :maxlength="maxl" v-model="modifyObj.ORMTB491CA05" />
							</div>
							<div class="systemCodePC-add-code-table-li-text">*必填*</div>
						</div>


						<div class="systemCodePC-add-code-table-li">
							<div class="systemCodePC-add-code-table-li-name">地址</div>
							<div class="systemCodePC-add-code-table-li-ipt" @click="adresOpiFun()">
								<input type="text" disabled style="pointer-events:none" v-model="modifyObj.ORMTB491CA01" />
							</div>
							<div class="systemCodePC-add-code-table-li-text">*必填*</div>
						</div>

					</div>
					<div class="systemCodePC-add-code-btn">
						<el-button type="warning" @click="cancelModify">取消</el-button>
						<el-button type="primary" @click="preservationModify">保存</el-button>
					</div>
				</div>
			</el-dialog>
		</div>
		<div class="public-dialog">
			<el-dialog title="地址选择" :visible.sync="DetailsWater" width="60%" :closeOnClickModal='false' append-to-body custom-class="system-settings-system-commercial-concrete-stand-dialog">
				<div style="max-height:600px;overflow-y: auto;">
					<div class="CustomerfillingDig-tab">
						<div>
							<!--地图显示-->
							<Map ref="map" @updateLocation="updateLocation" />
						</div>


					</div>

				</div>
				<div class="CustomerfillingDig-tab-btn">
					<el-button type="warning" @click="DetailsWater=false">取消</el-button>
					<el-button type="primary" @click="subOpiFun()">保存</el-button>
				</div>
			</el-dialog>
		</div>
	</div>
</template>

<script>
	import debounce from '../../api/debounce';
	import Map from '../sales/salesBigCustomers/aliMap.vue'
	export default {
		components: {
			Map
		},
		data() {
			return {

				inputVisible: false,
				inputValue: '',
				inputVisible2: false,
				inputValue2: '',


				formdata: new FormData(),

				loadingBut: false,
				confirmTxt: 0,
				isorderAuditText: '',
				oerderDetilsShow: false,
				orderAuditShow: false,
				isorderAuditShow: false,
				returnReceiptShow: false,
				uobj: this.$store.state.uobj, //登陆缓存--用户信息
				date: [], //日期
				startTime: '',
				endTime: '',
				dateNowDayActive: false,
				dateYesterdayActive: false,
				dateNowMonthActive: false,
				dateLastMonthActive: false,
				twolevelUserLogin: true,
				timeIndex: 0, //判断第几次切换当月时间
				sameMonthTime: '', //目前月份
				currentMonthTime: '', //目前月份--上月+1
				tableData: [],
				ORMTB440CA00: '',
				materialOptions: [],
				materialTypeValue: '',
				oilList: [{
					ORMTB473ID: '',
					ORMTB473CA00: '全部',
				}],
				carNum: '',
				materielMo: '',
				materielOptions: [{
					SETTB109CA00: '全部',
					SETTB109ID: '',
				}],

				maxl: 100,
				// 查询
				ORMTB473CA00: '', //商混站
				currentPage2: 1,
				detailsPageLimit2: 10,
				detailsCount2: 1,
				cdtableDataDetails: [],
				cdsUpdateShow: false,
				cdsUpdateObj: {
					ORMTB475ID: '',
					ORMTB475CA00: '',
					ORMTB475CA01: '',
					ORMTB475CA02: '',
					ORMTB475CA03: '',
					ORMTB475CA04: '',
					ORMTB475CA05: ''
				},
				cdleWaterDetails: false,
				rechargeTypeUpOBJ: {},
				rechargeTypeModifyDig: false,

				// 新增
				edCarNameModify: '',
				ORMTB473CA05ADD: '',
				ORMTB473CA00ADD: '',
				ORMTB473CA01ADD: '',
				ORMTB473CA02ADD: '',
				ORMTB473CA02ADD: '',
				ORMTB473CA03ADD: '',
				ORMTB473CA04ADD: '',
				ORMTB473CA06ADD: '',
				ORMTB473CA08ADD: '',
				ORMTB473CA10ADD: '',
				ORMTB473CA09ADD: [],
				ORMTB473CA09:'',
				ORMTB473CA06:'',


				modifyObj:{},

				//dialog
				billOperationAdd: false,
				billOperationDetails: false,

				pageMo: 1, //默认列表页码
				limitMo: 10, //每页的条数
				pagingPageMo: 0, //分页--数据列表共有的条数
				currentPage: 1, //设置当前页默认为1
				// 详情
				detailsList: '', //详情列表
				tableHeadList: [

					{
						prop: 'ORMTB491CA00',
						label: '名称',

					},
					{
						prop: 'ORMTB491CA04',
						label: '联系人',
					
					},
					{
						prop: 'ORMTB491CA05',
						label: '手机',

					},
					{
						prop: 'ORMTB491CA01',
						label: '地址',

					}
					// {
					// 	prop: 'ORMTB473CA03',
					// 	label: '飞砂走石价格',

					// }
					// {
					// 	prop: 'ORMTB473CA04',
					// 	label: '经度',

					// },
					// {
					// 	prop: 'ORMTB473CA05',
					// 	label: '维度',

					// },

				],

				isRefresh: true,
				// 历史缓存
				currentUrl: this.$route.path,
				historyInfo: '',
				// 时间限制
				// 限制开始日期不能超过当前日期
				startDateDisabled: {
					disabledDate(time) {
						return time.getTime() > Date.now();
					}
				},
				solelist: [],
				DetailsWaterurl: '',
				DetailsWatersrcList: [],
				DetailsWeightrcList: [],
				DetailsWeightrcBDList: [],
				ewmDetails: [],
				materialList: [],
				materialValue: '',
				listTick: null, // 列表刷新定时器
				timeType: '1',
				distf: true,
				mapPopUp: '',
				DetailsWater: false,
				psAdres: '',
				psxxAdres: '',
				objOpiData: {},
				longitude: '',
				latitude: '',
				dcmoreID: '',
				dcmore: '',
			}
		},
		watch: {
			weightOpt: {
				handler(val) {
					if ((val.tare || val.tare === 0) && (val.gross || val.gross === 0) && (val.price || val.price === 0)) {
						let tare = parseFloat(val.tare)
						let gross = parseFloat(val.gross)
						this.detailsList.ORMTB440CC04 = (tare - gross).toFixed(2)
						if (this.detailsList.ORMTB440CC04) {
							debounce(this.getSettlementAmount, 500)
						}
					} else {
						this.detailsList.ORMTB440CC04 = ''
						this.detailsList.ORMTB440CC06 = ''
					}
				},
				deep: true
			},
		},
		created() {
			var list = "";
			list = this.$store.state.solelist;
			// 赋值，缓存销毁
			this.historyInfo = JSON.parse(sessionStorage.getItem(this.currentUrl))
			sessionStorage.removeItem(this.currentUrl)
			if (this.historyInfo != null && this.historyInfo != '') {
				this.init()
			}
			// console.log(this.historyInfo)
			// else {
			// 	this.getNowDay();
			// }
			var path = this.$route.path;
			if (path === '/oilCardBill') {
				path = '/Home' + path
			}
			this.solelist = this.$baseAPI.querSoleList(list, path); //获取权限列表

			// console.log(this.solelist)
		},
		mounted() {
			if (this.historyInfo == null && this.$route.query.mark == null) {
				this.getNowDay();
				this.startTime = this.date[0];
				this.endTime = this.date[1];
				this.dateNowDayActive = true
			}

			// this.pageList()
			this.queryClick()
			// this.listTick = setInterval(() => {
			// 	this.queryClick()
			// }, 1000 * 60)

		},
		// 存储数据
		beforeDestroy() {
			clearInterval(this.listTick)
			this.listTick = null
			this.startTime = this.dateFtt("yyyy-MM-dd hh:mm:ss", new Date(this.date[0]));
			this.endTime = this.dateFtt("yyyy-MM-dd hh:mm:ss", new Date(this.date[1]));
			var obj = {
				startTime: this.startTime,
				endTime: this.endTime, //开始时间
				ORMTB440CA02: this.ORMTB440CA02, //客户id
				ORMTB400CA03: this.ORMTB400CA03, //客户名称
				ORMTB440CA04: this.ORMTB440CA04, //客户名称
				ORMTB440CA06: this.ORMTB440CA06, //二级企业id
				ORMTB440CF01: this.ORMTB440CF01, //二级企业名称
				ORMTB440CA00: this.ORMTB440CA00, //数据状态--转换
				ORMTB440CA01: this.ORMTB440CA01, //数据状态--名字
				currentPage: this.currentPage, //当前页数
				pageMo: this.pageMo, //页码
				limitMo: this.limitMo, //每页条数
				dateNowDayActive: this.dateNowDayActive,
				dateYesterdayActive: this.dateYesterdayActive,
				dateNowMonthActive: this.dateNowMonthActive,
				dateLastMonthActive: this.dateLastMonthActive,
				ORMTB440CA00: this.ORMTB440CA00
			}
			sessionStorage.setItem(this.currentUrl, JSON.stringify(obj))
		},
		computed: {

		},
		methods: {

			handleClose(tag) {
				this.ORMTB473CA09ADD.splice(this.ORMTB473CA09ADD.indexOf(tag), 1);
			},

			showInput() {
				this.inputVisible = true;
				this.$nextTick(_ => {
					this.$refs.saveTagInput.$refs.input.focus();
				});
			},

			handleInputConfirm() {
				let inputValue = this.inputValue;
				if (inputValue) {
					this.ORMTB473CA09ADD.push(inputValue);
				}
				this.inputVisible = false;
				this.inputValue = '';
			},

			handleClose2(tag) {
				this.ORMTB473CA09UP.splice(this.ORMTB473CA09UP.indexOf(tag), 1);
			},

			showInput2() {
				this.inputVisible2 = true;
				this.$nextTick(_ => {
					this.$refs.saveTagInput.$refs.input.focus();
				});
			},
			adresOpiFun() {
				this.DetailsWater = true
				
				console.log(this.modifyObj)
				
				// let Addr = {
				// 	lat:this.modifyObj.ORMTB491CA03,
				// 	lon:this.modifyObj.ORMTB491CA02 ,
				// 	orgAddr:this.modifyObj.ORMTB491CA01 ,
				// 	address:this.modifyObj.ORMTB491CA01,
				// 	province:this.modifyObj.ORMTB491CA06 ,
				// 	city:this.modifyObj.ORMTB491CA07
				// }
				
				// this.objOpiData.lat = this.modifyObj.ORMTB491CA03 
				// this.objOpiData.lon = this.modifyObj.ORMTB491CA02 
				// this.objOpiData.orgAddr = this.modifyObj.ORMTB491CA01 
				// this.objOpiData.address = this.modifyObj.ORMTB491CA01
				// this.objOpiData.province = this.modifyObj.ORMTB491CA06 
				// this.objOpiData.city = this.modifyObj.ORMTB491CA07 
				// this.updateLocation(Addr)
			},
			updateLocation(Addr) {
				console.log('位置信息：', Addr)
				this.objOpiData = Addr
			},
			subOpiFun() {
				this.DetailsWater = false
				if (this.mapPopUp == 0) {
					this.ORMTB473CA01ADD = this.objOpiData.orgAddr
					this.psxxAdres = this.objOpiData.address
					this.ORMTB473CA04ADD = this.objOpiData.lon
					this.ORMTB473CA05ADD = this.objOpiData.lat
				}
				if (this.mapPopUp == 1) {
					
					console.log(this.objOpiData)
					
					this.modifyObj.ORMTB491CA01 = this.objOpiData.orgAddr//地址
					this.modifyObj.ORMTB473CA11 = this.objOpiData.address//详细地址
					this.modifyObj.ORMTB473CA04 = this.objOpiData.lon//经度
					this.modifyObj.ORMTB473CA05 = this.objOpiData.lat//纬度
					
					this.modifyObj.ORMTB491CA06 = this.objOpiData.province//省
					this.modifyObj.ORMTB491CA07 = this.objOpiData.city//市
					this.modifyObj.ORMTB491CA10 = this.objOpiData.district//区
					
				}

			},
			rechargeTypeModifyClose() {

			},

			handleInputConfirm2() {
				let inputValue2 = this.inputValue2;
				if (inputValue2) {
					this.ORMTB473CA09UP.push(inputValue2);
				}
				this.inputVisible2 = false;
				this.inputValue2 = '';
			},


			//初始化数据
			init() {
				this.startTime = this.historyInfo.startTime
				this.endTime = this.historyInfo.endTime
				this.date = [this.startTime, this.endTime]
				this.ORMTB400CA03 = this.historyInfo.ORMTB400CA03
				this.ORMTB440CA06 = this.historyInfo.ORMTB440CA06
				this.ORMTB440CF01 = this.historyInfo.ORMTB440CF01
				this.ORMTB440CA00 = this.historyInfo.ORMTB440CA00
				this.ORMTB440CA01 = this.historyInfo.ORMTB440CA01
				this.currentPage = this.historyInfo.currentPage
				this.pageMo = this.historyInfo.pageMo
				this.limitMo = this.historyInfo.limitMo
				this.dateNowDayActive = this.historyInfo.dateNowDayActive
				this.dateYesterdayActive = this.historyInfo.dateYesterdayActive
				this.dateNowMonthActive = this.historyInfo.dateNowMonthActive
				this.dateLastMonthActive = this.historyInfo.dateLastMonthActive
				this.ORMTB440CA00 = this.historyInfo.ORMTB440CA00
			},
			// 导出
			// 查询
			queryClick() {
				this.pageMo = 1
				this.pageList()
			},
			// 新增取消--X
			XAdd() {
				// this.materielIndex = 0;
			},
			// 新增
			newlyAdd() {
				this.billOperationAdd = true;
				this.mapPopUp = 0 //新增
				this.ORMTB473CA05ADD = ''
				this.ORMTB473CA00ADD = ''
				this.ORMTB473CA01ADD = ''
				this.psxxAdres = ''
				this.ORMTB473CA03ADD = ''
				this.ORMTB473CA04ADD = ''
				this.ORMTB473CA06 = ''
				this.ORMTB473CA08ADD = ''
				this.ORMTB473CA09 = ''
				this.ORMTB473CA10ADD = ''
			},
			preservationAdd() {
				
				let loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});


				var postData = {
					ORMTB491CA06: this.objOpiData.province,//省
					ORMTB491CA07: this.objOpiData.city,//市
					ORMTB491CA10: this.objOpiData.district,//区
					ORMTB491CA03: this.ORMTB473CA05ADD, //纬度
					ORMTB491CA00: this.ORMTB473CA00ADD,//商混站名称
					ORMTB491CA04: this.ORMTB473CA06,//联系人
					ORMTB491CA01: this.ORMTB473CA01ADD, //商混站站地址
					// ORMTB473CA11: this.psxxAdres, //详细地址
					ORMTB491CA02: this.ORMTB473CA04ADD, //经度
					// ORMTB410ID: this.uobj.ormtb400.ORMTB400ID,//ID
					// ORMTB473CA08: this.ORMTB473CA08ADD,//公告
					// ORMTB473CA09: this.ORMTB473CA09,//油站价格
					ORMTB491CA05: this.ORMTB473CA10ADD,//手机号
				}
				var url = "/orm/ormtb491/saveOrmtb491Admin";
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.billOperationAdd = false;
						this.$message({
							message: '新增成功',
							type: 'success'
						});
						this.pageList();

					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close();
				})
			},
			cancelAdd() {
				this.billOperationAdd = false;
			},
			preservationModify() {
				// if (this.ORMTB473CA09UP.length < 1) {
				// 	this.$message({
				// 		message: "至少添加一个枪号",
				// 		type: 'error'
				// 	});
				// 	return
				// }

				let loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				
				console.log(this.modifyObj)
				// return
				var postData = {
					ORMTB491CA06: this.modifyObj.ORMTB491CA06,//省
					ORMTB491CA07: this.modifyObj.ORMTB491CA07,//市
					ORMTB491CA10: this.modifyObj.ORMTB491CA10,//区
					ORMTB491ID: this.modifyObj.ORMTB491ID, //ID
					ORMTB491CA03: this.modifyObj.ORMTB491CA03, //纬度
					ORMTB491CA00: this.modifyObj.ORMTB491CA00,//商混站名称
					ORMTB491CA01: this.modifyObj.ORMTB491CA01, //地址
					// ORMTB473CA11: this.modifyObj.ORMTB473CA11, //详细地址
					ORMTB491CA02: this.modifyObj.ORMTB491CA02, //经度
					ORMTB491CA04: this.modifyObj.ORMTB473CA06,//昵称
				
					ORMTB491CA05: this.modifyObj.ORMTB473CA10,//手机号
					ORMTB491CA08: this.modifyObj.msgFlag
				}
				
				
				var url = "/orm/ormtb491/updateOrmtb491Admin";
				this.axios.post(url, postData).then(res => {
					if (res.data.code == 200) {
						this.billOperationDetails = false;
						this.$message({
							message: '成功',
							type: 'success'
						});
						this.pageList();

					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close();
				})
			},
			cancelModify() {
				this.billOperationDetails = false;
			},
			exports() {
				// console.log(this.uobj)
				if (this.uobj.pertb005.pertb005cb00 == "CUS-2") {
					this.ORMTB474CA00 = this.uobj.ormtb410.ORMTB410ID //一级企业id

				}
				var startTime = this.date[0]; //开始时间
				var endTime = this.date[1]; //结束时间
				var ORMTB440CA02 = this.ORMTB474CA00; //二级客户ID
				var ORMTB400CA03 = 1002; //一级客户代码
				var ORMTB440CA04 = this.enterpriseTwo; //二级企业ID
				var ORMTB440CA06 = this.materielMo; //物料ID
				var ORMTB440CA00 = this.ORMTB440CA00; //订单号
				var ORMTB440CA01 = this.carNumber; //车牌号
				var timeType = this.timeType; //
				var url = this.axios.defaults.baseURL + "/exc/toExcel/ormtb440toExcle?startTime=" + startTime +
					"&endTime=" +
					endTime + "&ORMTB440CA02=" + ORMTB440CA02 + "&ORMTB400CA03=" + ORMTB400CA03 +
					"&ORMTB440CA04=" + ORMTB440CA04 + "&ORMTB440CA06=" + ORMTB440CA06 + "&ORMTB440CF01=" +
					ORMTB440CF01 + "&ORMTB440CA00=" + ORMTB440CA00 + "&ORMTB440CA01=" + ORMTB440CA01 + "&timeType=" +
					timeType;
				window.location.href = url;

				this.loadingBut = true
				var timer = null //倒计时
				this.confirmTxt = 30 - 1
				timer = setInterval(() => {
					if (this.confirmTxt === 0) {
						this.confirmTxt = ""
						this.loadingBut = false
						clearInterval(timer);
					} else {
						this.confirmTxt--
					}
				}, 1000);

			},


			// 取消订单
			cancelOrder(row) {
				var url = "/orm/ormtb440/updateORMTB440CF01";
				this.$prompt('请输入取消原因', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					inputPattern: /^.{1,}$/,
					inputErrorMessage: '原因不能为空'
				}).then(({
					value
				}) => {
					var postData = {
						ORMTB440ID: row.ORMTB440ID,
						ORMTB440CF01: -1, //状态
						ORMTB440CD01: value, //取消原因
					}
					let loading = this.$loading({
						lock: true,
						text: '请求中...',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.5)'
					});
					this.axios.post(url, postData).then(res => {
						if (res.data.code == 200) {
							this.pageList()
							this.$message({
								type: 'success',
								message: '取消成功!'
							});
						} else {
							this.$message({
								message: res.data.message,
								type: 'error'
							});
						}
						loading.close();
					}).catch(() => {
						loading.close();
					})
				})
			},
			// ch

			// 查询
			queryClick() {
				this.startTime = this.date[0];
				this.endTime = this.date[1];
				this.pageList()
			},
			// 列表
			pageList() {
				let loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var postData = {
					// startTime: this.startTime, //开始时间
					// endTime: this.endTime, //结束时间
					ORMTB491CA00: this.ORMTB473CA00,
					page: this.pageMo,
					limit: this.limitMo
					// timeType: this.timeType
				}
				this.tableData = [];
				var url = "/orm/ormtb491/ormtb491ListAdmin";
				this.axios.post(url, postData).then(res => {
					setTimeout(() => {
						loading.close()
					}, 400)
					// console.log(res)
					if (res.data.code == 200) {
						var data = res.data.data.list;
						this.pagingPageMo = res.data.data.total;
						for (var i = 0; i < data.length; i++) {
							var customerName = "";
							if (data[i]['ORMTB440CF01'] == '-1') {
								data[i]['ORMTB440CF01text'] = '取消'
							} else if (data[i]['ORMTB440CF01'] == '0') {
								data[i]['ORMTB440CF01text'] = '待接单'
							} else if (data[i]['ORMTB440CF01'] == '1') {
								data[i]['ORMTB440CF01text'] = '待提货'
							} else if (data[i]['ORMTB440CF01'] == '2') {
								data[i]['ORMTB440CF01text'] = '提货中'
							} else if (data[i]['ORMTB440CF01'] == '3') {
								data[i]['ORMTB440CF01text'] = '完成'
							} else if (data[i]['ORMTB440CF01'] == '4') {
								data[i]['ORMTB440CF01text'] = '已回执'
							} else if (data[i]['ORMTB440CF01'] == '5') {
								data[i]['ORMTB440CF01text'] = '确认回执'
							} else if (data[i]['ORMTB440CF01'] == '-2') {
								data[i]['ORMTB440CF01text'] = '申请取消'
							} else if (data[i]['ORMTB440CF01'] == '6') {
								data[i]['ORMTB440CF01text'] = '申请完成'
							}
							if (data[i]['ORMTB440CF01'] == '-2') {
								if (data[i]['ORMTB440CG00'] == '0') {
									data[i]['auditText'] = '未审核'
								} else if (data[i]['ORMTB440CG00'] == '1') {
									data[i]['auditText'] = '通过'
								} else if (data[i]['ORMTB440CG00'] == '2') {
									data[i]['auditText'] = '拒绝'
								}
							} else if (data[i]['ORMTB440CF01'] == '6') {
								data[i]['auditText'] = '未审核'
							} else {
								if (data[i].ORMTB440CH00 == 0) {
									data[i].isauditOrder = 0
								}
								if (data[i].ORMTB440CH00 == 1 && data[i].ORMTB440CH01 == 0) {
									data[i].isauditOrder = 1
								}
								if (data[i].ORMTB440CH00 == 1 && data[i].ORMTB440CH01 == 1) {
									data[i].isauditOrder = 0
								}
								if (data[i]['ORMTB440CH01'] == '0') {
									data[i]['auditText'] = '未审核'
								} else if (data[i]['ORMTB440CH01'] == '1') {
									data[i]['auditText'] = '通过'
								} else if (data[i]['ORMTB440CH01'] == '2') {
									data[i]['auditText'] = '拒绝'
								}
							}

							data[i]['msgFlag'] = 0
							if (data[i]['ORMTB440CA32'] != null) {
								try {
									let dataJs = JSON.parse(data[i]['ORMTB440CA32']);
									data[i]['msgFlag'] = dataJs.errcode
								} catch {
									console.log(data[i]['ORMTB440CA32'])
									data[i]['msgFlag'] = 1
								}
							}
						}
						this.tableData = data;

					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
				}).catch(() => {
					loading.close();
				})
			},
			// 详情
			DetailsClick(row) {
				this.oerderDetilsShow = true;
				this.querydetile(row)
			},

			modify(row) {
				this.billOperationDetails = true;
				this.modifyObj = row
				console.log(this.modifyObj)
				this.mapPopUp = 1 //修改

			},

			cduserClick(row) {
				this.cdsUpdateShow = true
				// this.cdsUpdateObj.ORMTB410ID = row.ORMTB473ID
				this.cdsUpdateObj.ORMTB475CA00 = row.ORMTB473ID
				this.cdsUpdateObj.ORMTB475CA01 = row.ORMTB410CA00
				this.cdsUpdateObj.ORMTB475CA02 = row.ORMTB410CA02
				// this.cdsUpdateObj.SETTB411CA03 = '0'
			},

			cdjlialClick(row) {
				this.cdleWaterDetails = true
				this.cdsUpdateObj.ORMTB475CA00 = row.ORMTB473ID
				this.queryCdWayTypeQuery()
			},
			queryCdWayTypeQuery() {
				this.cdtableDataDetails = []
				// this.detailsCount=0
				var url = "/orm/ormtb475/list"
				var loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var postData = {
					ORMTB475CA00: this.cdsUpdateObj.ORMTB475CA00
				}
				this.axios.post(url, postData).then(res => {
					if (res.data.code == 200) {
						this.cdtableDataDetails = res.data.data;
						this.detailsCount2 = res.data.count
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close()
				})
			},
			handleSizeChange2(val) {
				this.detailsPageLimit2 = val;
				this.currentPage2 = 1;
				// this.deductionRecordClick();
				this.queryWayTypeQuery()
			},
			handleCurrentChange2(val) {
				this.currentPage2 = val;
				// this.deductionRecordClick();
				this.queryCdWayTypeQuery()
			},

			cdsUpdateServe() {
				// if(!this.cdsUpdateObj.SETTB411CA03){
				//     this.$message.error('请选择是否冲抵')
				//     return;
				// }
				// if(!this.cdsUpdateObj.SETTB411CA04){
				//     this.$message.error('请输入金额')
				//     return;
				// }
				var url = "/orm/ormtb475/add"
				var loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var postData = this.cdsUpdateObj
				this.axios.post(url, postData).then(res => {
					if (res.data.code == 200) {
						this.$message.success('成功')
						// this.querycusList()
						this.cdsUpdateShow = false
						this.cdsUpdateObj = {
							ORMTB475ID: '',
							ORMTB475CA00: '',
							ORMTB475CA01: '',
							ORMTB475CA02: '',
							ORMTB475CA03: '',
							ORMTB475CA04: '',
							ORMTB475CA05: ''
						}
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close()
				})
			},
			rechargeTypeModify(row) {
				this.rechargeTypeModifyDig = true
				var str = JSON.stringify(row)
				this.rechargeTypeUpOBJ = JSON.parse(str)
				console.log(this.rechargeTypeUpOBJ)
			},
			deleteClick(row) {
				console.log(row)
				var postData = {
					ORMTB491ID: row.ORMTB491ID, //id
				}
				var url = "/orm/ormtb491/deleteOrmtb491Admin";
				this.$confirm('确定要删除,'+row.ORMTB491CA00+ '的信息吗?','提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.axios.post(url, postData).then(res => {
						// console.log(res)
						if (res.data.code == 200) {
							this.pageList()
							this.$message({
								type: 'success',
								message: '操作成功!'
							});
						} else {
							this.$message({
								message: res.data.message,
								type: 'error'
							});
						}
					})
				})
			},
			rechaTypePreserModify() {
				var url = "/orm/ormtb475/update"
				var loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var postData = this.rechargeTypeUpOBJ
				this.axios.post(url, postData).then(res => {
					if (res.data.code == 200) {
						this.$message.success('修改成功')
						this.queryCdWayTypeQuery()
						this.rechargeTypeModifyDig = false

						this.rechargeTypeUpOBJ = {}

					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close()
				})


			},

			orderAudit(row) {
				this.orderAuditShow = true
				this.querydetile(row)
			},
			isorderAudit(row) {
				this.isorderAuditShow = true
				this.querydetile(row)
			},
			returnReceipt(row) {
				this.returnReceiptShow = true
				this.querydetile(row)
			},


			querydetile(row) {
				var postData = {
					ORMTB440ID: row.ORMTB440ID, //流水id
				}
				this.detailsList = ''
				var url = "/orm/ormtb440/selectDetails";
				this.axios.post(url, postData).then(res => {
					if (res.data.code == 200) {
						this.detailsList = res.data.data;
						this.DetailsWatersrcList = [this.detailsList.ORMTB440CE01]
						if (this.detailsList.ORMTB440CH05) this.DetailsWeightrcList = [this.detailsList
							.ORMTB440CH05
						]
						if (this.detailsList.ORMTB440CL01) this.DetailsWeightrcBDList = [this.detailsList
							.ORMTB440CL01
						]
						this.DetailsWaterurl = this.detailsList.ORMTB440CE01
						if (this.detailsList.ORMTB440CF01 == 6 || (row.ORMTB440CF01 == 0 && row.ORMTB440CA22)) {
							this.weightOpt.price = this.detailsList.ORMTB440CC03
							if (this.detailsList.ORMTB440CC06 == 0) this.detailsList.ORMTB440CC06 = ''
							this.weightOpt.tare = this.detailsList.ORMTB440CC05
							this.weightOpt.gross = (this.detailsList.ORMTB440CC05 - this.detailsList.ORMTB440CC04)
								.toFixed(2)
							this.getSelectMaterial()
						}
						// else if (this.detailsList.ORMTB440CF01 == 0) {
						// 	this.weightOpt.price = this.detailsList.ORMTB440CC03
						// 	this.getSelectMaterial()
						// }

					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}

				})
			},
			queryermdetile(row) {
				var postData = {
					ORMTB440ID: row.ORMTB440ID, //流水id
				}
				this.detailsList = ''
				var url = "/orm/ormtb440/getErwei";
				this.axios.post(url, postData).then(res => {
					if (res.data.code == 200) {
						this.ewmdetailsList = res.data.data;
						this.ewmdetailsList.ORMTB440CA22Img = 'data:image/png;base64,' + res.data.data
							.ORMTB440CA22;

					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}

				})
			},

			dateFtt(fmt, date) { //author: meizz
				var o = {
					"M+": date.getMonth() + 1, //月份
					"d+": date.getDate(), //日
					"h+": date.getHours(), //小时
					"m+": date.getMinutes(), //分
					"s+": date.getSeconds(), //秒
					"q+": Math.floor((date.getMonth() + 3) / 3), //季度
					"S": date.getMilliseconds() //毫秒
				};
				if (/(y+)/.test(fmt))
					fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
				for (var k in o)
					if (new RegExp("(" + k + ")").test(fmt))
						fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k])
							.length)));
				return fmt;
			},

			//获取当前时间
			getNowDay() {
				var date = new Date().getTime();
				var Ming = new Date().getTime() + 24 * 60 * 60 * 1000;
				var data = this.dateFtt('yyyy-MM-dd', new Date(Ming))
				var enddata = this.dateFtt('yyyy-MM-dd', new Date(date))
				data = `${data} ${this.exchangeTiem||'00:00:00'}`
				enddata = `${enddata} ${this.exchangeTiem||'00:00:00'}`
				this.date = [enddata, data];
				this.dateNowDayActive = true
				this.dateYesterdayActive = false
				this.dateNowMonthActive = false
				this.dateLastMonthActive = false
			},
			datePickerChange(e) {
				this.dateNowDayActive = false
				this.dateYesterdayActive = false
				this.dateNowMonthActive = false
				this.dateLastMonthActive = false
			},
			//获取昨天时间
			getYesterday() {
				var hms = new Date().getTime() - 24 * 60 * 60 * 1000;
				var Ming = new Date().getTime();
				var nowDay = this.dateFtt('yyyy-MM-dd', new Date(hms))
				var enddata = this.dateFtt('yyyy-MM-dd', new Date(Ming))
				nowDay = `${nowDay} ${this.exchangeTiem||'00:00:00'}`
				enddata = `${enddata} ${this.exchangeTiem||'00:00:00'}`
				this.date = [nowDay, enddata];
				this.dateNowDayActive = false
				this.dateYesterdayActive = true
				this.dateNowMonthActive = false
				this.dateLastMonthActive = false
			},
			//获取当月时间
			sameMonth() {
				var date = new Date();
				var hms = date.setDate(1);
				var firstDay = this.dateFtt('yyyy-MM-dd', new Date(hms));
				firstDay = `${firstDay} ${this.exchangeTiem||'00:00:00'}`
				var nextdate = new Date().getTime() + 24 * 60 * 60 * 1000;
				var nextDay = this.dateFtt('yyyy-MM-dd', new Date(nextdate));
				nextDay = `${nextDay} ${this.exchangeTiem||'00:00:00'}`
				this.date = [firstDay, nextDay];
				this.startTime = this.date[0];
				this.endTime = this.date[1];
				this.dateNowDayActive = false
				this.dateYesterdayActive = false
				this.dateNowMonthActive = true
				this.dateLastMonthActive = false
			},
			//获取上月时间
			lastMonth() {
				var nowdays = new Date();
				var year = nowdays.getFullYear();
				var month = nowdays.getMonth();
				var lastyear = year
				var lastmonth = month
				if (month == 0) {
					month = 12;
					year = year - 1;
				}
				if (month == 12) {
					lastmonth = 1
				} else {
					lastmonth = lastmonth + (1 * 1)
				}
				if (month < 10) {
					month = "0" + month;
				}
				if (lastmonth < 10) {
					lastmonth = "0" + lastmonth;
				}
				var firstDayOfPreMonth = year + "-" + month + "-" + "01";
				var firstDayOfPreMonth = `${year}-${month}-01 ${this.exchangeTiem||'00:00:00'}`;
				// var lastDay = new Date(lastyear, lastmonth, 0);
				let lastDayOfPreMonth = `${lastyear}-${lastmonth}-01 ${this.exchangeTiem||'00:00:00'}`;
				this.date = [firstDayOfPreMonth, lastDayOfPreMonth];
				this.dateNowDayActive = false
				this.dateYesterdayActive = false
				this.dateNowMonthActive = false
				this.dateLastMonthActive = true
			},
			handleSizeChange(val) {
				this.pageMo = 1
				this.limitMo = val;
				this.pageList();
			},
			// 点击页码
			handleCurrentChange(val) {
				this.pageMo = val;
				this.pageList();
			},
		}
	}
</script>

<style scoped>

	.DWD-li {
		display: flex;
		height: 35px;
		line-height: 35px;
		box-sizing: border-box;
		border: 1px solid #999;
		font-size: 16px;
		color: #333;
	}

	.DWD-li>div {
		padding: 0 5px;
		height: 34px;
		overflow: hidden;
		box-sizing: border-box;
	}

	.DWD-li-title {
		width: 120px;
		text-align: center;
		border-right: 1px solid #999;
		background-color: rgba(0, 163, 255, .1);
	}

	.DWD-li-text {
		flex: 1;
	}

	.DWD-li-text input {
		width: 100%;
		height: 35px;
		line-height: 35px;
		border: none;
		outline: none;
	}

	.DWD-li+.DWD-li {
		border-top: none;
	}

	.DWD-table {
		display: flex;
	}

	.DWD-table-left-flex {
		flex: 1;
	}

	.DWD-table>div>div {
		padding: 0 5px;
		height: 35px;
		line-height: 35px;
		overflow: hidden;
		text-align: center;
		border-right: 1px solid #999;
		border-bottom: 1px solid #999;
		box-sizing: border-box;
	}

	.DWD-table>div>div:first-child {
		background-color: rgba(0, 163, 255, .1);
	}

	.DWD-table-left-title>div {
		width: 101px;
		text-align: center;
		background-color: rgba(0, 163, 255, .1);
	}

	.DWD-table .DWD-table-left-title>div {
		padding: 0 5px;
		height: 35px;
		line-height: 35px;
		overflow: hidden;
		box-sizing: border-box;
		border-left: 1px solid #999;
		border-bottom: 1px solid #999;
	}

	.DetailsWater-img {
		margin-top: 30px;
	}

	.DetailsWater-img-text {
		display: inline-block;
		width: 101px;
		text-align: center;
		vertical-align: top;
	}

	.car-number-add {
		/* text-transform: uppercase; */
	}

	.billOperationRecord-table {
		padding: 30px 20px 0;
	}

	.public_singleMenu .pulic_carNumber {
		margin-top: 6px;
		height: 40px;
		line-height: 40px;
		box-sizing: border-box;
		font-size: 14px;
		display: inline-block;
	}

	.pulic_operatArea_now:hover,
	.public_operatArea_yesterday:hover {
		background-color: #ccc;
	}

	/* 新增--列表宽度 */
	.billOperationRecord .systemCodePC-add-code-table-li-ipt {
		flex: 1.5;
	}

	.fontBlue {
		color: rgba(25, 159, 255, 1) !important;
	}

	.public_oparetionBlock_Menu .pulic_carNumber {
		margin-top: 6px;
		height: 40px;
		line-height: 40px;
		box-sizing: border-box;
		font-size: 14px;
		display: inline-block;
	}

	.billOperationRecord .public_oparetionBlock_Menu {
		height: 45px;
		align-items: center;
	}

	.billOperationRecord {
		background-color: #f3f3f3;
	}

	.billOperationRecord th,
	.billOperationRecord td {
		text-align: center !important;
	}

	.carManagement {
		background: #f3f3f3;
	}

	.bcarManagement-table {
		padding: 30px 20px 0;
	}

	.test111:active {
		background-color: red !important;
	}

	/* 新增--列表宽度 */
	.billOperationRecord .systemCodePC-add-code-table-li-ipt {
		flex: 1.5;
	}

	.fontBlue {
		color: rgba(25, 159, 255, 1) !important;
	}

	.public_oparetionBlock_Menu .pulic_carNumber {
		margin-top: 6px;
		height: 40px;
		line-height: 40px;
		box-sizing: border-box;
		font-size: 14px;
		display: inline-block;
	}

	.billOperationRecord .public_oparetionBlock_Menu {
		height: 45px;
		align-items: center;
	}

	.billOperationRecord {
		background-color: #f3f3f3;
	}

	.billOperationRecord th,
	.billOperationRecord td {
		text-align: center !important;
	}

	/* 弹框 */
	.systemCodePC-add-code {
		padding: 0 20px;
	}
	.systemCodePC-pagesize {
		text-align: right;
		margin-top: 20px;
	}
</style>
<style>
	.demo-table-expand {
		font-size: 0;
	}

	.demo-table-expand label {
		width: 90px;
		color: #99a9bf;
	}

	.demo-table-expand .el-form-item {
		margin-right: 0;
		margin-bottom: 0;
		width: 50%;
	}

	.itemMsg {
		padding: 0 10px;
	}

	.demo-table-expand .item-lxxx .el-form-item__content {
		width: 500px;
	}

	.el-tag+.el-tag {
		margin-left: 10px;
	}

	.button-new-tag {
		margin-left: 10px;
		height: 22px;
		line-height: 30px;
		padding-top: 0;
		padding-bottom: 0;
	}

	.input-new-tag {
		width: auto;
		margin-left: 10px;
		vertical-align: baseline;
		/*vertical-align: bottom;*/
	}
	.nameshz-clas{
		width: 100px;
	}
</style>
<style>
.system-settings-system-commercial-concrete-stand-dialog {
	border: 1px solid rgba(207, 225, 245, 0.95);
	border-radius: 18px;
	background: #f8fbff;
	box-shadow: 0 24px 70px rgba(18, 52, 77, 0.22);
	overflow: hidden;
}

.system-settings-system-commercial-concrete-stand-dialog .el-dialog__header {
	position: relative;
	height: auto;
	line-height: normal;
	padding: 18px 54px 16px 24px;
	vertical-align: middle;
	background: linear-gradient(135deg, #f5fbff 0%, #ffffff 48%, #eef8ff 100%);
	border-bottom: 1px solid rgba(219, 233, 247, 0.95);
	color: #17324d;
}

.system-settings-system-commercial-concrete-stand-dialog .el-dialog__header::before {
	content: "";
	position: absolute;
	left: 0;
	top: 0;
	width: 5px;
	height: 100%;
	background: linear-gradient(180deg, #199fff 0%, #5ac8fa 100%);
}

.system-settings-system-commercial-concrete-stand-dialog .el-dialog__title {
	font-size: 18px;
	font-weight: 700;
	color: #17324d !important;
	letter-spacing: .2px;
}

.system-settings-system-commercial-concrete-stand-dialog .el-dialog__headerbtn {
	top: 13px;
	right: 18px;
	border-radius: 50%;
	background: rgba(25, 159, 255, 0.08);
	transition: background .2s ease, transform .2s ease;
}

.system-settings-system-commercial-concrete-stand-dialog .el-dialog__headerbtn:hover {
	background: rgba(25, 159, 255, 0.16);
	transform: rotate(90deg);
}

.system-settings-system-commercial-concrete-stand-dialog .el-dialog__headerbtn .el-dialog__close {
	vertical-align: middle;
	font-size: 18px;
	color: #55708b !important;
}

.system-settings-system-commercial-concrete-stand-dialog .el-dialog__body {
	max-height: calc(90vh - 130px);
	padding: 22px 24px 24px;
	background: linear-gradient(180deg, #ffffff 0%, #f7fbff 100%);
	color: #31445a;
	overflow-y: auto;
}

.system-settings-system-commercial-concrete-stand-dialog .systemCodePC-add-code {
	padding: 0;
}

.system-settings-system-commercial-concrete-stand-dialog .systemCodePC-add-code-table {
	display: flex;
	flex-direction: column;
	gap: 12px;
}

.system-settings-system-commercial-concrete-stand-dialog .systemCodePC-add-code-table-li {
	display: grid;
	grid-template-columns: 120px minmax(0, 1fr) 64px;
	align-items: center;
	gap: 10px;
	min-height: 46px;
	padding: 10px 12px;
	border: 1px solid rgba(220, 232, 245, 0.9);
	border-radius: 12px;
	background: rgba(255, 255, 255, 0.88);
	box-shadow: 0 6px 16px rgba(23, 77, 124, 0.05);
	box-sizing: border-box;
}

.system-settings-system-commercial-concrete-stand-dialog .systemCodePC-add-code-table-li-name {
	color: #203a56;
	font-size: 14px;
	font-weight: 600;
	text-align: right;
}

.system-settings-system-commercial-concrete-stand-dialog .systemCodePC-add-code-table-li-ipt {
	min-width: 0;
}

.system-settings-system-commercial-concrete-stand-dialog .systemCodePC-add-code-table-li-ipt input,
.system-settings-system-commercial-concrete-stand-dialog .systemCodePC-add-code-table-li-ipt .el-input__inner {
	width: 100%;
	height: 36px;
	line-height: 36px;
	padding: 0 12px;
	border: 1px solid #d7e5f3;
	border-radius: 9px;
	background: #fff;
	color: #1f3449;
	box-sizing: border-box;
	transition: border-color .18s ease, box-shadow .18s ease;
}

.system-settings-system-commercial-concrete-stand-dialog .systemCodePC-add-code-table-li-ipt input:focus,
.system-settings-system-commercial-concrete-stand-dialog .systemCodePC-add-code-table-li-ipt .el-input__inner:focus {
	border-color: #199fff;
	box-shadow: 0 0 0 3px rgba(25, 159, 255, 0.12);
	outline: none;
}

.system-settings-system-commercial-concrete-stand-dialog .systemCodePC-add-code-table-li-ipt input:disabled {
	background: #f3f7fb;
	color: #7a8ca0;
	cursor: pointer;
}

.system-settings-system-commercial-concrete-stand-dialog .systemCodePC-add-code-table-li-text {
	color: #ff6b6b;
	font-size: 12px;
	white-space: nowrap;
}

.system-settings-system-commercial-concrete-stand-dialog .systemCodePC-add-code-btn,
.system-settings-system-commercial-concrete-stand-dialog .CustomerfillingDig-tab-btn {
	display: flex;
	justify-content: space-between;
	gap: 16px;
	margin: 22px 0 0;
	padding-top: 18px;
	border-top: 1px solid rgba(223, 235, 247, 0.9);
}

.system-settings-system-commercial-concrete-stand-dialog .systemCodePC-add-code-btn .el-button,
.system-settings-system-commercial-concrete-stand-dialog .CustomerfillingDig-tab-btn .el-button {
	min-width: 96px;
	border-radius: 9px;
	margin-left: 0;
}

.system-settings-system-commercial-concrete-stand-dialog .systemCodePC-add-code-btn .el-button--warning,
.system-settings-system-commercial-concrete-stand-dialog .CustomerfillingDig-tab-btn .el-button--warning {
	order: 1;
}

.system-settings-system-commercial-concrete-stand-dialog .systemCodePC-add-code-btn .el-button--primary,
.system-settings-system-commercial-concrete-stand-dialog .CustomerfillingDig-tab-btn .el-button--primary {
	order: 2;
}

.system-settings-system-commercial-concrete-stand-dialog .CustomerfillingDig-tab {
	border: 1px solid rgba(220, 232, 245, 0.9);
	border-radius: 14px;
	overflow: hidden;
	background: #ffffff;
}

@media screen and (max-width: 768px) {
	.system-settings-system-commercial-concrete-stand-dialog {
		width: calc(100vw - 24px) !important;
	}

	.system-settings-system-commercial-concrete-stand-dialog .el-dialog__body {
		padding: 18px 16px 20px;
	}

	.system-settings-system-commercial-concrete-stand-dialog .systemCodePC-add-code-table-li {
		grid-template-columns: 1fr;
		gap: 8px;
	}

	.system-settings-system-commercial-concrete-stand-dialog .systemCodePC-add-code-table-li-name {
		text-align: left;
	}
}

.system-commercial-concrete-stand-page {
	position: relative;
	min-height: 100%;
	box-sizing: border-box;
	padding: 16px;
	background:
		radial-gradient(circle at 86% 6%, rgba(34, 126, 214, .14), transparent 28%),
		radial-gradient(circle at 5% 30%, rgba(62, 178, 128, .12), transparent 24%),
		linear-gradient(180deg, #edf5fb 0%, #f8fbfd 48%, #f9fbfc 100%);
	--stand-primary: #227ed6;
	--stand-accent: #22a879;
	--stand-text: #22384d;
	--stand-muted: #708399;
	--stand-border: #d9e6f2;
	--stand-shadow: 0 14px 34px rgba(34, 58, 84, .1);
	font-family: "Microsoft YaHei", sans-serif;
}

.system-commercial-concrete-stand-page .commercial-stand-filter-panel,
.system-commercial-concrete-stand-page .commercial-stand-table-card {
	box-sizing: border-box;
	border: 1px solid rgba(217, 230, 242, .95);
	border-radius: 18px;
	background: rgba(255, 255, 255, .96);
	box-shadow: var(--stand-shadow);
}

.system-commercial-concrete-stand-page .commercial-stand-filter-panel {
	padding: 18px 20px;
}

.system-commercial-concrete-stand-page .commercial-stand-filter-head,
.system-commercial-concrete-stand-page .commercial-stand-table-head {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 16px;
}

.system-commercial-concrete-stand-page .commercial-stand-filter-title,
.system-commercial-concrete-stand-page .commercial-stand-table-title {
	position: relative;
	padding-left: 12px;
	color: var(--stand-text);
	font-size: 18px;
	font-weight: 800;
	line-height: 1.35;
}

.system-commercial-concrete-stand-page .commercial-stand-filter-title::before,
.system-commercial-concrete-stand-page .commercial-stand-table-title::before {
	content: "";
	position: absolute;
	left: 0;
	top: 4px;
	width: 4px;
	height: 18px;
	border-radius: 8px;
	background: linear-gradient(180deg, var(--stand-primary), var(--stand-accent));
}

.system-commercial-concrete-stand-page .commercial-stand-filter-subtitle {
	margin-top: 6px;
	color: var(--stand-muted);
	font-size: 13px;
}

.system-commercial-concrete-stand-page .commercial-stand-filter-count,
.system-commercial-concrete-stand-page .commercial-stand-table-tag {
	flex: 0 0 auto;
	padding: 8px 14px;
	border: 1px solid rgba(34, 126, 214, .14);
	border-radius: 999px;
	background: linear-gradient(135deg, rgba(34, 126, 214, .1), rgba(34, 168, 121, .12));
	color: #1c63ad;
	font-size: 13px;
	font-weight: 700;
}

.system-commercial-concrete-stand-page .commercial-stand-filter-controls {
	display: flex;
	flex-wrap: wrap;
	align-items: center !important;
	gap: 12px 14px;
	margin: 18px 0 0;
	padding: 14px;
	border: 1px solid rgba(217, 230, 242, .82);
	border-radius: 14px;
	background: linear-gradient(180deg, #fbfdff 0%, #f5f9fd 100%);
}

.system-commercial-concrete-stand-page .commercial-stand-filter-item {
	display: flex;
	align-items: center;
	gap: 10px;
	height: auto;
	margin: 0;
}

.system-commercial-concrete-stand-page .commercial-stand-filter-item .public_lbSty {
	width: auto;
	min-width: 96px;
	color: var(--stand-text);
	font-weight: 700;
}

.system-commercial-concrete-stand-page .commercial-stand-filter-item .public_optionSty,
.system-commercial-concrete-stand-page .commercial-stand-filter-item .el-input,
.system-commercial-concrete-stand-page .commercial-stand-filter-item .pulic_carNumber {
	width: 240px !important;
}

.system-commercial-concrete-stand-page .commercial-stand-filter-item .pulic_carNumber {
	height: 40px;
	line-height: 40px;
	margin-top: 0;
	padding: 0 12px;
	border: 1px solid var(--stand-border);
	border-radius: 10px;
	background: #ffffff;
	color: var(--stand-text);
	box-sizing: border-box;
}

.system-commercial-concrete-stand-page .commercial-stand-filter-item .pulic_carNumber:focus {
	border-color: var(--stand-primary);
	box-shadow: 0 0 0 3px rgba(34, 126, 214, .13);
	outline: none;
}

.system-commercial-concrete-stand-page .commercial-stand-action-area {
	margin-top: 14px;
}

.system-commercial-concrete-stand-page .commercial-stand-action-btns {
	display: flex;
	gap: 12px;
	align-items: center;
}

.system-commercial-concrete-stand-page .commercial-stand-action-btns button {
	height: 38px;
	min-width: 92px;
	padding: 0 18px;
	border: none;
	border-radius: 10px;
	font-weight: 700;
	box-shadow: 0 9px 18px rgba(34, 126, 214, .16);
}

.system-commercial-concrete-stand-page .commercial-stand-action-btns .public_saleWater_chaxun {
	background: linear-gradient(135deg, var(--stand-primary), #35a1f4) !important;
	color: #ffffff !important;
}

.system-commercial-concrete-stand-page .commercial-stand-action-btns .public_saleWater_xinzeng {
	background: linear-gradient(135deg, var(--stand-accent), #48c891) !important;
	color: #ffffff !important;
}

.system-commercial-concrete-stand-page .commercial-stand-table-card {
	padding: 18px 18px 0;
	overflow: hidden;
}

.system-commercial-concrete-stand-page .commercial-stand-table-head {
	margin-bottom: 16px;
	padding-bottom: 14px;
	border-bottom: 1px solid rgba(217, 230, 242, .76);
}

.system-commercial-concrete-stand-page .commercial-stand-main-table {
	border-radius: 14px;
	overflow: hidden;
}

.system-commercial-concrete-stand-page .commercial-stand-main-table::before {
	display: none;
}

.system-commercial-concrete-stand-page .commercial-stand-main-table th {
	background: linear-gradient(180deg, #f4f9ff 0%, #eaf4ff 100%) !important;
}

.system-commercial-concrete-stand-page .commercial-stand-main-table th .cell {
	color: #24384b;
	font-size: 14px;
	font-weight: 800;
	white-space: nowrap;
}

.system-commercial-concrete-stand-page .commercial-stand-main-table td {
	padding: 10px 0;
	border-bottom: 1px solid rgba(225, 234, 244, .86);
}

.system-commercial-concrete-stand-page .commercial-stand-main-table .el-table__row:hover > td {
	background: #f4f9ff !important;
}

.system-commercial-concrete-stand-page .commercial-stand-main-table .public_icon_width {
	min-width: 78px;
	height: 32px;
	padding: 0 12px;
	border: none;
	border-radius: 999px;
	font-weight: 700;
}

.system-commercial-concrete-stand-page .pulbic_pagesize {
	display: flex;
	justify-content: flex-end;
	align-items: center;
	gap: 12px;
	padding: 14px 0 4px;
	margin-top: 10px;
	text-align: right;
}

@media screen and (max-width: 768px) {
	.system-commercial-concrete-stand-page .commercial-stand-filter-head,
	.system-commercial-concrete-stand-page .commercial-stand-table-head {
		align-items: flex-start;
		flex-direction: column;
	}

	.system-commercial-concrete-stand-page .commercial-stand-filter-item,
	.system-commercial-concrete-stand-page .commercial-stand-filter-item .public_optionSty,
	.system-commercial-concrete-stand-page .commercial-stand-filter-item .el-input,
	.system-commercial-concrete-stand-page .commercial-stand-filter-item .pulic_carNumber,
	.system-commercial-concrete-stand-page .commercial-stand-action-btns button {
		width: 100% !important;
	}

	.system-commercial-concrete-stand-page .commercial-stand-action-btns {
		flex-direction: column;
	}
}
</style>
